import { colorMix } from "../../theme/AppTheme";

export function getButtonColors(color, variant, { text, bg }) {
    const theme = {
        primary: { text: "var(--primary-contrast)", bg: "var(--primary)" },
        secondary: { text: "var(--text)", bg: "var(--secondary)" },
        error: { text: "white", bg: "var(--error)" },
        success: { text: "white", bg: "var(--success)" },
        warning: { text: "white", bg: "var(--warning)" },
        info: { text: "white", bg: "var(--info)" },
    }[color] ?? { text: "var(--text)", bg: "var(--bg)" };

    text ??= theme.text;
    bg ??= theme.bg;

    return (
        {
            contained: { bg, text, border: bg, shadow: colorMix(bg, 20) },

            /* On a transparent background the foreground must be the colour
               itself — its *contrast* value is meant for filled buttons, and
               using it here paints paper-on-paper (invisible). */
            outlined: {
                bg: "transparent",
                text: bg,
                border: bg,
                shadow: colorMix(bg, 20),
            },

            soft: {
                bg: colorMix(bg, 20),
                text: bg,
                border: colorMix(bg, 20),
                shadow: colorMix(bg, 20),
            },

            "soft-outlined": {
                bg: "transparent",
                text: bg,
                border: colorMix(bg, 35),
                shadow: colorMix(bg, 20),
            },

            text: {
                bg: "transparent",
                border: "transparent",
                ...(!color || color === "default"
                    ? {
                          text,
                          shadow: colorMix(text, 20),
                      }
                    : { text: bg, shadow: colorMix(bg, 20) }),
            },
        }[variant] ?? { bg, text, border: bg, shadow: colorMix(bg, 20) }
    );
}
